module.exports = __webpack_public_path__ + "img/video-play-button.f6551eb1.svg";